import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

import ProgressBar from "./ProgressBar";
import IframeResizer from "iframe-resizer-react";

import "../styles/main.css";

//let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
let iOSversion;
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
  iOSversion = [
    parseInt(v[1], 10),
    parseInt(v[2], 10),
    parseInt(v[3] || 0, 10),
  ];
} else {
  iOSversion = [];
}
let iOS12orLess = false;
if (iOSversion[0] <= 12) {
  iOS12orLess = true;
}

export class SecondPage extends Component {
  componentDidMount() {
    this.checkPriceCombination();
    this.saveToLocalStorage();
    window.scrollTo(0, 0);
  }

  checkPriceCombination = () => {
    this.props.checkPriceCombination();
  };

  saveToLocalStorage = () => {
    this.props.saveToLocalStorage();
  };

  continue = (e) => {
    e.preventDefault();
    // PROCESS FORM //
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  handleChangeCoupon = (e) => {
    e.preventDefault();
    this.props.handleChangeCoupon(e);
  };

  enterCouponCode = (e) => {
    // e.preventDefault();
    this.props.enterCouponCode(this.props.couponInput);
  };

  render() {
    const { cancel, tempClassesArray } = this.props;
    let iframeSrc;
    switch (tempClassesArray.length) {
      // case 1:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=bVdXOHBWaitxQ1dER3U0czRHeFlRdz09"; /*149 nis*/
      //   break;
      // case 2:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=NHc4djNaZytiK09LNzM2YjE2MFgxZz09"; /*298 NIS*/
      //   break;
      // case 3:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=RCtENWVCRkhYQU0yNHZ5NEtLbm8xZz09"; /*447 NIS*/
      //   break;
      // case 4:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=bmNKNE0xK1JiNHdyWmc5bnJWaVdjQT09"; /*596 NIS*/
      //   break;
      // case 5:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=ZXVxTmVaUEVNQzY1Um00WEFkVHJ1dz09"; /*745 NIS*/
      //   break;
      // case 6:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=cGNqVmhwdlIwWXhEVWFjM1o3VUZ6UT09"; /*894 NIS*/
      //   break;
      // case 7:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=K0lCYVhHd2dYUG12WkV3UWlsRGJXdz09"; /*1043 NIS*/
      //   break;
      // case 8:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=RWkySW5OVk03b0RLL1c0Yml6VnVGUT09"; /*1192 NIS*/
      //   break;
      // case 9:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=eUFRWnVjK2tJUGo5SXNJd2R6cEE1QT09"; /*1341 NIS*/
      //   break;
      // case 10:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=TlNSQkF0QzZJTzREUit2V3dqTTZpQT09"; /*1490  NIS*/
      //   break;
      // default:
      //   iframeSrc =
      //     "https://app.upay.co.il/API6/s.php?m=bVdXOHBWaitxQ1dER3U0czRHeFlRdz09"; /*149  NIS*/
      //   break;
           case 1:
        iframeSrc =
          "https://meshulam.co.il/s/53cbe20d-acc6-6c79-7d91-7de223339ac0"; /*55 NIS*/
        break;
      case 2:
        iframeSrc =
          "https://meshulam.co.il/s/0743ebb6-89d2-bab5-c370-c5a6d4399b30"; /*110 NIS*/
        break;
      case 3:
        iframeSrc =
          "https://meshulam.co.il/s/d68e425b-f0cf-e9c5-4069-8dde68afd73a"; /*165 NIS*/
        break;
      case 4:
        iframeSrc =
          "https://meshulam.co.il/s/5b9bc433-6f67-63a5-a9c8-ae60d6919867"; /*220 NIS*/
        break;
      case 5:
        iframeSrc =
          "https://meshulam.co.il/s/f8b21829-87c3-f18e-61fc-becd0eb0e6da"; /*275 NIS*/
        break;
      case 6:
        iframeSrc =
          "https://meshulam.co.il/s/7e3fcd7d-0da5-1b9d-c14b-59b8c505d4ed"; /*330 NIS*/
        break;
      default:
        iframeSrc =
          "https://meshulam.co.il/s/53cbe20d-acc6-6c79-7d91-7de223339ac0"; /*55  NIS*/
        break;
    }

    return (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid item xs={4}>
            <div className="white-space-side">
              <img
                className="pageImg"
                src={require("../assets/carousel-img/Page1.png")}
                title="first page"
                alt="pic"
              />
            </div>
          </Grid>
          <Grid item xs={8}>
            <div style={{ direction: "rtl", marginleft: "125px" }}>
              <ProgressBar currStep={this.props.currStep} />
            </div>

            <div className="SecondPageForm">
              <div className="coupon-wrapper">
                <div className="iframe-holder">
                  <div className="iframe-wrapper">
                    {this.props.showLoader ? (
                      <div className="loader-iframe">
                        <CircularProgress
                          style={{
                            color: "#32C6A9",
                            width: "100px",
                            height: "100px",
                          }}
                        />
                      </div>
                    ) : null}

                    {/* CHECK IF IOS IS LESS THAN 13 */}
                    {iOS12orLess ? (
                      <IframeResizer
                        src={iframeSrc}
                        onLoad={this.props.hideLoader}
                        style={{
                          width: "1px",
                          minWidth: "100%",

                          overflowY: "scroll",
                        }}
                        scrolling="no"
                      />
                    ) : (
                      <IframeResizer
                        src={iframeSrc}
                        onLoad={this.props.hideLoader}
                        style={{
                          width: "1px",
                          minWidth: "100%",
                          height: "1px",
                          minHeight: "100%",
                          overflowY: "scroll",
                        }}
                        scrolling="yes"
                      />
                    )}
                  </div>
                </div>
              </div>

              {this.props.openMessageModal ? (
                <div id="myModal" class="modal">
                  <div class="modal-content">
                    <p>הקוד שהכנסת שגוי</p>
                    <button
                      onClick={this.props.handleModalClose}
                      className="modal-close"
                      style={{ background: "#fff" }}
                    >
                      ok
                    </button>
                  </div>
                </div>
              ) : null}

              <div className="button-container" dir="rtl">
                <div
                  className="button-back"
                  variant="contained"
                  onClick={this.back}
                >
                  <i
                    className="material-icons"
                    style={{
                      fontSize: "32px",
                      marginLeft: "5px",
                      marginRight: "-12px",
                    }}
                  >
                    keyboard_arrow_right
                  </i>
                  חזור
                </div>

                <div
                  className="button-cancel"
                  variant="contained"
                  onClick={cancel}
                >
                  לבטל
                </div>
              </div>
              <p
                className="contact-text-bottom"
                variant="caption"
                display="block"
              >
                לכל שאלה, בעיה אנחנו כאן
                <br />
                טלפון: <a href={"tel:052-8808558"}>052-8808558</a> מייל:{" "}
                <a href={"mailto:contact@class.me"}>contact@class.me</a>
                <a className="terms" href={"https://class.me/termsHE.html"}>
                  תנאי שימוש ומדיניות פרטיות
                </a>
              </p>
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default SecondPage;
